export default {
   SET_COUNT_CHECKINS(state, checkins){
       state.count_checkin = checkins;
   },
    SET_CHECKINS(state, checkins) {
       state.checkins = checkins;
    }
  };